import { Injectable, Inject, OnDestroy } from '@angular/core';
import * as XLSX from 'xlsx';
import { environment } from '../../environments/environment';
import { forkJoin, Observable } from 'rxjs';
import { AuthService } from '../modules/auth/_services/auth.service';
import { TableService, TableResponseModel, ITableState, PaginatorState, GroupingState, SortState } from '../_metronic/shared/crud-table';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RecursosService } from './recursos.service';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService extends TableService<any> {
  // API_URL_LICENCIAS  = `${environment.apiUrl}/licencia/export`;
  // MC GPO-131 Versionado de API
  API_URL_LICENCIAS = this.url + this.recursos.LICENCIA.EXPORT.VERSION + this.recursos.LICENCIA.PATH_BASE + this.recursos.LICENCIA.EXPORT.PATH_REL;

  constructor(@Inject(HttpClient) http, @Inject(AuthService) auths, @Inject(RecursosService) recursosService) {
    super(http,auths,recursosService);
  }
  /* Funcion que dado una tabla html, un nombre de archivo y un numero de columna a borrar
    realiza la exportacion a archivo xls de la misma. */
  public exportAsExcelFile(table: any, excelFileName: string, colDelete: number): void {
    
    //const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(table);
    const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(table,  {raw:true});
    ws['!cols'] = [];
    ws['!cols'][colDelete] = { hidden: true }; 
    ws['!cols'][colDelete+1] = { hidden: true }; 
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Listado');

    /* save to file */
    XLSX.writeFile(wb, excelFileName + EXCEL_EXTENSION);
  }
  /* Funcion que dado un json y un nombre de archivo realiza la exportacion a archivo xls de la misma. */
  public exportAsExcelJson(json: any, excelFileName: string): void {
    
    //const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(table);
    const ws: XLSX.WorkSheet=XLSX.utils.json_to_sheet(json);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Listado');

    /* save to file */
    XLSX.writeFile(wb, excelFileName + EXCEL_EXTENSION);
  }

  public exportAsExcelFileComplete(api_url: string, params: any): Observable<Blob>{
    return this.http.get(api_url,{params: params, responseType: 'blob'});   
  }

}